import script from "./Meta.vue?vue&type=script&lang=ts"
export * from "./Meta.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__